<template>
  <div>
    <p>
      お知らせの通知&nbsp;:&nbsp;{{ noticeType }}
      <app-button class="default" @click="openEditForm">変更</app-button>
    </p>
    <div v-if="!emails.length && notice === '1'" class="text-danger">
      メールアドレスが登録されていません。
      <br />
      「メールで通知する」を設定するまで通知が届きませんのでご注意ください。
    </div>
    <hr />
    <Title title="通知先メールアドレス" />
    <app-button class="default mb-3" @click="openAddForm">メールアドレスを登録</app-button>

    <b-table style="width: 400px" thead-class="d-none" v-if="emails.length" :items="emails" :fields="emailFields">
      <template v-slot:cell(management)="data">
        <b-nav>
          <b-nav-item @click="openEditEmailForm(data.item.id, data.item.email)">編集</b-nav-item>
          <b-nav-item @click="deleteEmail(data.item.id, data.item.email)">削除</b-nav-item>
        </b-nav>
      </template>
    </b-table>
    <div v-else>メールアドレスは登録されていません。</div>
    <hr />
    <Title title="パスワードの変更" />
    <app-button class="default mb-3" @click="openPasswordEditForm">パスワードを変更する</app-button>
    <b-modal id="config-email-modal" :no-close-on-backdrop="true" :title="modalTitle" :hide-footer="true">
      <ConfigEmailEdit
        v-bind:id="emailid"
        :no-close-on-backdrop="true"
        v-bind:email="email"
        @update="update"
        @closeModal="closeEditEmailForm"
      ></ConfigEmailEdit>
    </b-modal>
    <b-modal id="config-modal" :title="modalTitle" :hide-footer="true">
      <ConfigEdit
        v-bind:state="configStateList"
        v-bind:typeid="this.notice"
        @update="update"
        @closeModal="closeEditForm"
      ></ConfigEdit>
    </b-modal>
    <b-modal id="password-modal" :title="modalTitle" :hide-footer="true" size="lg">
      <PasswordEdit @update="update" @closeModal="closePasswordEditForm"></PasswordEdit>
    </b-modal>
  </div>
</template>

<script>
import api from '@/api'
import { getErrorStatus } from '@/transformer/base'
import Title from '@/components/Title.vue'
import ConfigEdit from '@/components/ConfigEdit.vue'
import ConfigEmailEdit from '@/components/ConfigEmailEdit.vue'
import PasswordEdit from '@/components/PasswordEdit.vue'
import AppButton from '@/components/presentationals/AppButton'

export default {
  name: 'Config',
  components: {
    Title,
    ConfigEdit,
    ConfigEmailEdit,
    PasswordEdit,
    AppButton
  },
  data() {
    return {
      status: [
        { value: '0', text: 'メールで通知しない' },
        { value: '1', text: 'メールで通知する' }
      ],
      emailid: 0,
      email: null,
      modalTitle: 'メールアドレスの新規登録'
    }
  },
  props: ['notice', 'emails'],
  computed: {
    emailFields() {
      return [{ key: 'email' }, { key: 'management' }]
    },
    noticeType() {
      if (this.notice === '0') {
        return 'メールで通知しない'
      } else {
        return 'メールで通知する'
      }
    },
    configStateList() {
      return this.status.map((val) => {
        return { text: val.text, value: Number(val.value) }
      })
    }
  },
  methods: {
    async openAddForm() {
      this.modalTitle = 'メールアドレスの新規登録'
      this.emailid = 0
      this.email = null
      this.$nextTick().then((e) => {
        this.$bvModal.show('config-email-modal')
      })
    },
    async openEditForm() {
      this.modalTitle = '通知の設定'
      this.$nextTick().then((e) => {
        this.$bvModal.show('config-modal')
      })
    },
    async openEditEmailForm(id, mail) {
      this.modalTitle = 'メールアドレスの編集'
      this.emailid = id
      this.email = mail
      this.$nextTick().then((e) => {
        this.$bvModal.show('config-email-modal')
      })
    },
    async openPasswordEditForm() {
      this.modalTitle = 'パスワードの変更'
      this.$nextTick().then((e) => {
        this.$bvModal.show('password-modal')
      })
    },
    closeEditForm() {
      this.$bvModal.hide('config-modal')
      this.$emit('update')
    },
    closeEditEmailForm() {
      this.$bvModal.hide('config-email-modal')
      this.$emit('update')
    },
    closePasswordEditForm() {
      this.$bvModal.hide('password-modal')
      this.$emit('update')
    },
    deleteEmail(id, email) {
      this.$bvModal
        .msgBoxConfirm(`メールアドレス「${email}」を削除してよろしいですか？`, {
          title: '確認',
          okTitle: 'OK',
          okVariant: 'default',
          cancelTitle: 'キャンセル',
          hideHeaderClose: false
        })
        .then(async (bool) => {
          if (!bool) {
            return
          }

          try {
            await api.config.deleteNoticeEmail(id)

            this.$root.$bvToast.toast(`メールアドレス「${email}」を削除しました。`, {
              variant: 'success',
              toaster: 'b-toaster-top-center',
              autoHideDelay: 3000
            })

            this.$emit('update')
          } catch (err) {
            const apiStatus = getErrorStatus(err)
            const errorMessages = []
            for (const key in apiStatus.errors) {
              errorMessages.push(`・${apiStatus.errors[key]}`)
            }
            this.$root.$bvToast.toast(errorMessages.join('\n'), {
              variant: 'danger',
              toaster: 'b-toaster-top-center',
              toastClass: 'pre-wrap',
              noAutoHide: true
            })
          }
        })
    },
    update() {
      this.$emit('update')
    }
  }
}
</script>
